export const NAVIGATION_LOAD_ERROR = 'NAVIGATION_LOAD_ERROR';
export const SEARCH_LOAD_ERROR = 'SEARCH_LOAD_ERROR';

export const PaginationOptions = {
    PageSize: 8,
    DisplayedEntries: 3, 
    EdgeEntries: 1,
    Page: 0
};
export const NAVIGATION_RECEIVE = 'NAVIGATION_RECEIVE';
export const SEARCH_RECEIVE = 'SEARCH_RECEIVE';
export const LANGUAGE_RECEIVE_LANGUAGES = 'NAVIGATION_RECEIVE_LANGUAGES';
export const LANGUAGE_CURRENT_CLASSNAME = 'LANGUAGE_CURRENT_CLASSNAME';
export const LANGUAGE_RECEIVE_DICTIONARIES = 'LANGUAGE_RECEIVE_DICTIONARIES';
export const LANGUAGE_LOAD_ERROR = 'LANGUAGE_LOAD_ERROR';
export const LANGUAGE_CURRENT = 'LANGUAGE_CURRENT';